import { useContext } from "react";
import { ViewStateContext } from "../UrlParser/UrlParser";
import { LinearInterpolator } from "react-map-gl";

import HomeIcon from "@mui/icons-material/Home";
import IconButton from "@mui/material/IconButton";
import StyledTooltip from "../UI/StyledTooltip";

import { iconButtonStyle, styles } from "../../config/config.theme";

import { homePosition } from "../../config/config.layout";

const Home = () => {
  const { setViewState } = useContext(ViewStateContext);

  const handleClick = () => {
    setViewState({
      latitude: 37.09024,
      longitude: -95.712891,
      zoom: 3,
      transitionDuration: 700,
      transitionInterpolator: new LinearInterpolator(),
    });
  };

  return (
    <StyledTooltip
      title="Reset map"
      placement={
        homePosition.tooltipPlacement ? homePosition.tooltipPlacement : "right"
      }
      disableFocusListener
      enterTouchDelay={0}
    >
      <IconButton
        aria-label="reset map"
        variant="outlined"
        onClick={handleClick}
        sx={{
          ...iconButtonStyle,
          "&:hover": { backgroundColor: styles["background-primary"] },
          "&:active": { backgroundColor: styles["background-primary"] },
          "&:focus": { backgroundColor: styles["background-primary"] },
        }}
      >
        <HomeIcon fontSize="1.5rem" color="primary" />
      </IconButton>
    </StyledTooltip>
  );
};

export default Home;
